// extracted by mini-css-extract-plugin
module.exports = {"forumPanel":"styles-module__forumPanel___VmZng"};